module.exports = __webpack_public_path__ + "img/thankyou_survey.57299ca4.png";